import { Directive, ElementRef, HostListener, inject, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appAutoSize]',
  standalone: true,
})
export class AutoSizeDirective {
  private readonly elementRef = inject(ElementRef);
  private readonly renderer2 = inject(Renderer2);

  @HostListener('input') onInput() {
    this.renderer2.setStyle(this.elementRef.nativeElement, 'height', 'auto');
    this.renderer2.setStyle(
      this.elementRef.nativeElement,
      'height',
      this.elementRef.nativeElement.scrollHeight + 'px',
    );
  }
}
